// extracted by css-extract-rspack-plugin
export default {"cls1":"WorkCard-cls1_SsR","cls2":"WorkCard-cls2_A3L WorkCard-cls1_SsR"};